import CreateDynamicFormFieldRequestModelBase from '../_generated/modelBases/create-dynamic-form-field-request-model-base';

export default class CreateDynamicFormFieldRequestModel extends CreateDynamicFormFieldRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
